import { appToolbarHeightPx } from '@lbcamden/lib-react';
import { formatPlural, parseDate } from '@lbcamden/shared-utils';
import { DateTime } from 'luxon';

export const scrollCardIntoView = (cardElement: HTMLDivElement) => {
  // Scroll to the top of the card with an offset to account for the toolbar
  const scrollTop =
    cardElement.getBoundingClientRect().top -
    document.body.getBoundingClientRect().top -
    (appToolbarHeightPx + 20);

  // Ensures the scroll occurs after the card content has rendered
  window.requestAnimationFrame(() => window.scrollTo({ top: scrollTop }));
};

export const getPersonAge = (dob: string) => {
  const duration = DateTime.now().diff(parseDate(dob), ['years', 'months', 'days']);

  const years = Math.floor(duration.years);
  const months = Math.floor(duration.months);
  const days = Math.floor(duration.days);

  if (years > 0) {
    return `${years} ${formatPlural('year', years)}`;
  }
  if (months > 0) {
    return `${months} ${formatPlural('month', months)}`;
  }
  return `${days} ${formatPlural('day', days)}`;
};
